const ensureTrailingSlash = (url) => (url.endsWith("/") ? url : `${url}/`);

export const PROD_BASE_URL = "https://medimind.in";
export const PROD_CHAT_BASE = `${PROD_BASE_URL}/api/chat/`;
// http://127.0.0.1:8000
export const CHAT_BASE = ensureTrailingSlash(
  import.meta?.env?.VITE_CHAT_BASE || PROD_CHAT_BASE
);
